/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { orderTypeSchema } from "./orderTypeSchema.ts";
import { scheduleSchema } from "./scheduleSchema.ts";
import { tgButtonsSchema } from "./tgButtonsSchema.ts";
import { workModeEnumSchema } from "./workModeEnumSchema.ts";

export const branchSchema = z.object({
	id: z.uuid(),
	name: z.string().max(100),
	work_mode: workModeEnumSchema.optional().describe("* `table-service` - Ресторан\n* `fast-food` - Фастфуд"),
	buttons: z.array(tgButtonsSchema),
	qr_order_minimum_price: z.int(),
	schedule: scheduleSchema,
	delivery_cost: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.nullish()
		.describe("Если отделение имеет платную доставку, то необходимо ее указать(если не задано, доставка не осуществляется)"),
	order_types: z.array(orderTypeSchema),
});
